/**
 * FilterButtonAccordion
 */
import React from 'react';
import clsx from 'clsx';
import { Icon } from 'ui-component-library/base';
import { Transition } from 'react-transition-group';
/** Main description for this component. */
var FilterButtonAccordion = function (_a) {
    var text = _a.text, id = _a.id, expanded = _a.expanded, onClick = _a.onClick, className = _a.className, children = _a.children;
    return (React.createElement("div", { "data-cid": "FilterButtonAccordionItem" },
        React.createElement("button", { onClick: onClick, id: "accordion-button-" + id, "aria-controls": "accordion-content-" + id, "aria-expanded": expanded, className: clsx('flex justify-between items-center w-full border-2 border-greyLight px-4 pt-2 pb-2 rounded-lg rounded-b-none text-medium border-b-0', expanded ? 'bg-white text-black' : 'bg-greyLight text-teal', className) },
            React.createElement("span", null, text),
            React.createElement(Icon, { icon: "chevron", direction: expanded ? 'down' : 'up', "aria-hidden": true })),
        React.createElement(Transition, { in: expanded, timeout: 400 }, function (state) { return (React.createElement("div", { id: "accordion-content-" + id, role: "region", "aria-labelledby": "accordion-button-" + id, hidden: state === 'exited', className: clsx(state === 'exiting' ? 'animate-fade-out' : 'animate-fade-in') }, children)); })));
};
export default FilterButtonAccordion;
